export default __webpack_public_path__ + "static/media/mimic.9028920f.png";